import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagementBaseUrl, userManagement } from '../endpoints';

// Define a service using a base URL and expected endpoints
export const cityService = createApi({
  reducerPath: "cityService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["city"],
  endpoints: (builder) => ({
    getAllCities: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.cityController.getAllCities}/${body.stateId}`,
          method: "GET",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      }
    }),
    
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAllCitiesMutation } = cityService;
